import {Checkbox as $b50e47f9c64ebdde$export$48513f6b9f8ce62d} from "../checkbox/Checkbox.mjs";
import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {InsertionIndicator as $9b909c804a6da52e$export$2c0bab5914a9d088} from "./InsertionIndicator.mjs";
import $9YFnB$intlStringsmjs from "./intlStrings.mjs";
import {Menu as $8cccdb0b63bfcdeb$export$d9b273488cd8ce6f} from "../menu/Menu.mjs";
import {MenuTrigger as $9928637078ff3033$export$27d2ad3c5815583e} from "../menu/MenuTrigger.mjs";
import {Nubbin as $883c77333b1378a3$export$d9658cdf8c86807} from "./Nubbin.mjs";
import {ProgressCircle as $1cfe37e7feefa23d$export$c79b9d6b4cc92af7} from "../progress/ProgressCircle.mjs";
import {Resizer as $5d98d27e710cc12e$export$48a76196cafe3b93, ResizeStateContext as $5d98d27e710cc12e$export$b517d84d4ad20b24} from "./Resizer.mjs";
import {RootDropIndicator as $104a371d434f1691$export$d30a7814cfd4033e} from "./RootDropIndicator.mjs";
import {DragPreview as $98bc3ab36527e684$export$905ab40ac2179daa} from "./DragPreview.mjs";
import "../table_vars.css";
import $9YFnB$table_vars_cssmjs from "../table_vars_css.mjs";
import "./table.css";
import $9YFnB$table_cssmjs from "./table_css.mjs";
import {TableViewLayout as $3c62b2c154012fbc$export$725d101278f5a47b} from "./TableViewLayout.mjs";
import {Tooltip as $91ff1bc0856186a6$export$28c660c63b792dea} from "../tooltip/Tooltip.mjs";
import {TooltipTrigger as $1db3f28f9989b2cd$export$8c610744efcf8a1d} from "../tooltip/TooltipTrigger.mjs";
import {useDOMRef as $3c2c983d5210446c$export$c2c55ef9111cafd8, useFocusableRef as $3c2c983d5210446c$export$96a734597687c040, useUnwrapDOMRef as $3c2c983d5210446c$export$1d5cc31d9d8df817} from "../utils/useDOMRef.mjs";
import {useProvider as $71dfb0e0358a12de$export$693cdb10cec23617, useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import $9YFnB$spectrumiconsuiArrowDownSmall from "@spectrum-icons/ui/ArrowDownSmall";
import $9YFnB$spectrumiconsuiChevronDownMedium from "@spectrum-icons/ui/ChevronDownMedium";
import $9YFnB$spectrumiconsuiChevronLeftMedium from "@spectrum-icons/ui/ChevronLeftMedium";
import $9YFnB$spectrumiconsuiChevronRightMedium from "@spectrum-icons/ui/ChevronRightMedium";
import {FocusRing as $9YFnB$FocusRing} from "react-aria/FocusRing";
import {FocusScope as $9YFnB$FocusScope} from "react-aria/FocusScope";
import {isFocusWithin as $9YFnB$isFocusWithin, getActiveElement as $9YFnB$getActiveElement} from "react-aria/private/utils/shadowdom/DOMFunctions";
import {getInteractionModality as $9YFnB$getInteractionModality, isFocusVisible as $9YFnB$isFocusVisible} from "react-aria/private/interactions/useFocusVisible";
import {useHover as $9YFnB$useHover} from "react-aria/useHover";
import {isAndroid as $9YFnB$isAndroid} from "react-aria/private/utils/platform";
import {Item as $9YFnB$Item} from "react-stately/Item";
import {layoutInfoToStyle as $9YFnB$layoutInfoToStyle, VirtualizerItem as $9YFnB$VirtualizerItem} from "react-aria/private/virtualizer/VirtualizerItem";
import $9YFnB$spectrumiconsuiListGripper from "@spectrum-icons/ui/ListGripper";
import {ListKeyboardDelegate as $9YFnB$ListKeyboardDelegate} from "react-aria/ListKeyboardDelegate";
import {mergeProps as $9YFnB$mergeProps} from "react-aria/mergeProps";
import $9YFnB$react, {useContext as $9YFnB$useContext, useRef as $9YFnB$useRef, useEffect as $9YFnB$useEffect, useState as $9YFnB$useState, useMemo as $9YFnB$useMemo, useCallback as $9YFnB$useCallback} from "react";
import {scrollIntoView as $9YFnB$scrollIntoView, scrollIntoViewport as $9YFnB$scrollIntoViewport} from "react-aria/private/utils/scrollIntoView";
import {ScrollView as $9YFnB$ScrollView} from "react-aria/private/virtualizer/ScrollView";
import {setScrollLeft as $9YFnB$setScrollLeft} from "react-aria/private/virtualizer/utils";
import {useTableColumnResizeState as $9YFnB$useTableColumnResizeState} from "react-stately/useTableState";
import {useButton as $9YFnB$useButton} from "react-aria/useButton";
import {useFocusRing as $9YFnB$useFocusRing} from "react-aria/useFocusRing";
import {useLoadMore as $9YFnB$useLoadMore} from "react-aria/private/utils/useLoadMore";
import {useLocale as $9YFnB$useLocale} from "react-aria/I18nProvider";
import {useLocalizedStringFormatter as $9YFnB$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";
import {usePress as $9YFnB$usePress} from "react-aria/usePress";
import {useTable as $9YFnB$useTable, useTableRowGroup as $9YFnB$useTableRowGroup, useTableColumnHeader as $9YFnB$useTableColumnHeader, useTableSelectAllCheckbox as $9YFnB$useTableSelectAllCheckbox, useTableRow as $9YFnB$useTableRow, useTableHeaderRow as $9YFnB$useTableHeaderRow, useTableCell as $9YFnB$useTableCell, useTableSelectionCheckbox as $9YFnB$useTableSelectionCheckbox} from "react-aria/useTable";
import {useVirtualizerState as $9YFnB$useVirtualizerState} from "react-stately/useVirtualizerState";
import {VisuallyHidden as $9YFnB$VisuallyHidden, useVisuallyHidden as $9YFnB$useVisuallyHidden} from "react-aria/VisuallyHidden";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 















































const $2a45525f66468ec9$var$DEFAULT_HEADER_HEIGHT = {
    medium: 34,
    large: 40
};
const $2a45525f66468ec9$var$DEFAULT_HIDE_HEADER_CELL_WIDTH = {
    medium: 38,
    large: 46
};
const $2a45525f66468ec9$var$ROW_HEIGHTS = {
    compact: {
        medium: 32,
        large: 40
    },
    regular: {
        medium: 40,
        large: 50
    },
    spacious: {
        medium: 48,
        large: 60
    }
};
const $2a45525f66468ec9$var$SELECTION_CELL_DEFAULT_WIDTH = {
    medium: 38,
    large: 48
};
const $2a45525f66468ec9$var$DRAG_BUTTON_CELL_DEFAULT_WIDTH = {
    medium: 16,
    large: 20
};
const $2a45525f66468ec9$var$LEVEL_OFFSET_WIDTH = {
    medium: 16,
    large: 20
};
const $2a45525f66468ec9$export$93e4b0b2cc49b648 = /*#__PURE__*/ (0, $9YFnB$react).createContext(null);
function $2a45525f66468ec9$export$3cb274deb6c2d854() {
    return (0, $9YFnB$useContext)($2a45525f66468ec9$export$93e4b0b2cc49b648);
}
const $2a45525f66468ec9$export$d288a7dd40372bc = /*#__PURE__*/ (0, $9YFnB$react).createContext(null);
function $2a45525f66468ec9$export$3f8f74b6bfd2c5df() {
    return (0, $9YFnB$useContext)($2a45525f66468ec9$export$d288a7dd40372bc);
}
function $2a45525f66468ec9$var$TableViewBase(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    let { isQuiet: isQuiet, onAction: onAction, onResizeStart: propsOnResizeStart, onResizeEnd: propsOnResizeEnd, dragAndDropHooks: dragAndDropHooks, state: state } = props;
    let isTableDraggable = !!dragAndDropHooks?.useDraggableCollectionState;
    let isTableDroppable = !!dragAndDropHooks?.useDroppableCollectionState;
    let dragHooksProvided = (0, $9YFnB$useRef)(isTableDraggable);
    let dropHooksProvided = (0, $9YFnB$useRef)(isTableDroppable);
    (0, $9YFnB$useEffect)(()=>{
        if (process.env.NODE_ENV === 'production') return;
        if (dragHooksProvided.current !== isTableDraggable) console.warn('Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
        if (dropHooksProvided.current !== isTableDroppable) console.warn('Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
        if ('keyMap' in state && (isTableDraggable || isTableDroppable)) console.warn('Drag and drop is not yet fully supported with expandable rows and may produce unexpected results.');
    }, [
        isTableDraggable,
        isTableDroppable,
        state
    ]);
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(props);
    let { scale: scale } = (0, $71dfb0e0358a12de$export$693cdb10cec23617)();
    // Starts when the user selects resize from the menu, ends when resizing ends
    // used to control the visibility of the resizer Nubbin
    let [isInResizeMode, setIsInResizeMode] = (0, $9YFnB$useState)(false);
    // Starts when the resizer is actually moved
    // entering resizing/exiting resizing doesn't trigger a render
    // with table layout, so we need to track it here
    let [, setIsResizing] = (0, $9YFnB$useState)(false);
    let domRef = (0, $3c2c983d5210446c$export$c2c55ef9111cafd8)(ref);
    let headerRef = (0, $9YFnB$useRef)(null);
    let bodyRef = (0, $9YFnB$useRef)(null);
    let density = props.density || 'regular';
    let layout = (0, $9YFnB$useMemo)(()=>new (0, $3c62b2c154012fbc$export$725d101278f5a47b)({
            // If props.rowHeight is auto, then use estimated heights based on scale, otherwise use fixed heights.
            rowHeight: props.overflowMode === 'wrap' ? undefined : $2a45525f66468ec9$var$ROW_HEIGHTS[density][scale],
            estimatedRowHeight: props.overflowMode === 'wrap' ? $2a45525f66468ec9$var$ROW_HEIGHTS[density][scale] : undefined,
            headingHeight: props.overflowMode === 'wrap' ? undefined : $2a45525f66468ec9$var$DEFAULT_HEADER_HEIGHT[scale],
            estimatedHeadingHeight: props.overflowMode === 'wrap' ? $2a45525f66468ec9$var$DEFAULT_HEADER_HEIGHT[scale] : undefined
        }), // don't recompute when state.collection changes, only used for initial value
    [
        props.overflowMode,
        scale,
        density
    ]);
    let dragState = null;
    let preview = (0, $9YFnB$useRef)(null);
    if (isTableDraggable && dragAndDropHooks) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: state.collection,
            selectionManager: state.selectionManager,
            preview: preview
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, domRef);
    }
    let DragPreview = dragAndDropHooks?.DragPreview;
    let dropState = null;
    let droppableCollection = null;
    let isRootDropTarget = false;
    if (isTableDroppable && dragAndDropHooks) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: state.collection,
            selectionManager: state.selectionManager
        });
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: new (0, $9YFnB$ListKeyboardDelegate)({
                collection: state.collection,
                disabledKeys: state.selectionManager.disabledKeys,
                ref: domRef,
                layoutDelegate: layout
            }),
            dropTargetDelegate: layout
        }, dropState, domRef);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { gridProps: gridProps } = (0, $9YFnB$useTable)({
        ...props,
        isVirtualized: true,
        layoutDelegate: layout,
        onRowAction: onAction,
        scrollRef: bodyRef
    }, state, domRef);
    let [headerMenuOpen, setHeaderMenuOpen] = (0, $9YFnB$useState)(false);
    let [headerRowHovered, setHeaderRowHovered] = (0, $9YFnB$useState)(false);
    // This overrides collection view's renderWrapper to support DOM hierarchy.
    let renderWrapper = (0, $9YFnB$useCallback)((parent, reusableView, children, renderChildren)=>{
        if (reusableView.viewType === 'rowgroup') return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableRowGroup, {
            key: reusableView.key,
            layoutInfo: reusableView.layoutInfo,
            parent: parent?.layoutInfo ?? null,
            // Override the default role="rowgroup" with role="presentation",
            // in favor or adding role="rowgroup" to the ScrollView with
            // ref={bodyRef} in the TableVirtualizer below.
            role: "presentation"
        }, renderChildren(children));
        if (reusableView.viewType === 'header') return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableHeader, {
            key: reusableView.key,
            layoutInfo: reusableView.layoutInfo,
            parent: parent?.layoutInfo ?? null
        }, renderChildren(children));
        if (reusableView.viewType === 'row') return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableRow, {
            key: reusableView.key,
            item: reusableView.content,
            layoutInfo: reusableView.layoutInfo,
            parent: parent?.layoutInfo ?? null
        }, renderChildren(children));
        if (reusableView.viewType === 'headerrow') return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableHeaderRow, {
            onHoverChange: setHeaderRowHovered,
            key: reusableView.key,
            layoutInfo: reusableView.layoutInfo,
            parent: parent?.layoutInfo ?? null,
            item: reusableView.content
        }, renderChildren(children));
        return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableCellWrapper, {
            key: reusableView.key,
            layoutInfo: reusableView.layoutInfo,
            virtualizer: reusableView.virtualizer,
            parent: parent
        }, reusableView.rendered);
    }, []);
    let renderView = (0, $9YFnB$useCallback)((type, item)=>{
        switch(type){
            case 'header':
            case 'rowgroup':
            case 'section':
            case 'row':
            case 'headerrow':
                return null;
            case 'cell':
                if (item.props.isSelectionCell) return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableCheckboxCell, {
                    cell: item
                });
                if (item.props.isDragButtonCell) return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableDragCell, {
                    cell: item
                });
                return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableCell, {
                    cell: item
                });
            case 'placeholder':
                // TODO: move to react-aria?
                return /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
                    role: "gridcell",
                    "aria-colindex": item.index + 1,
                    "aria-colspan": item.colSpan != null && item.colSpan > 1 ? item.colSpan : undefined
                });
            case 'column':
                if (item.props.isSelectionCell) return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableSelectAllCell, {
                    column: item
                });
                if (item.props.isDragButtonCell) return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableDragHeaderCell, {
                    column: item
                });
                // TODO: consider this case, what if we have hidden headers and a empty table
                if (item.props.hideHeader) return /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $1db3f28f9989b2cd$export$8c610744efcf8a1d), {
                    placement: "top",
                    trigger: "focus"
                }, /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableColumnHeader, {
                    column: item
                }), /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $91ff1bc0856186a6$export$28c660c63b792dea), {
                    placement: "top"
                }, item.rendered));
                if (item.props.allowsResizing && !item.hasChildNodes) return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$ResizableTableColumnHeader, {
                    column: item
                });
                return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableColumnHeader, {
                    column: item
                });
            case 'loader':
                return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$LoadingState, null);
            case 'empty':
                return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$EmptyState, null);
        }
        return null;
    }, []);
    let [isVerticalScrollbarVisible, setVerticalScollbarVisible] = (0, $9YFnB$useState)(false);
    let [isHorizontalScrollbarVisible, setHorizontalScollbarVisible] = (0, $9YFnB$useState)(false);
    let viewport = (0, $9YFnB$useRef)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    let onVisibleRectChange = (0, $9YFnB$useCallback)((e)=>{
        if (viewport.current.width === e.width && viewport.current.height === e.height) return;
        viewport.current = e;
        if (bodyRef.current) {
            setVerticalScollbarVisible(bodyRef.current.clientWidth + 2 < bodyRef.current.offsetWidth);
            setHorizontalScollbarVisible(bodyRef.current.clientHeight + 2 < bodyRef.current.offsetHeight);
        }
    }, []);
    let { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $9YFnB$useFocusRing)();
    let isEmpty = state.collection.size === 0;
    let onFocusedResizer = ()=>{
        if (bodyRef.current && headerRef.current) bodyRef.current.scrollLeft = headerRef.current.scrollLeft;
    };
    let onResizeStart = (0, $9YFnB$useCallback)((widths)=>{
        setIsResizing(true);
        propsOnResizeStart?.(widths);
    }, [
        setIsResizing,
        propsOnResizeStart
    ]);
    let onResizeEnd = (0, $9YFnB$useCallback)((widths)=>{
        setIsInResizeMode(false);
        setIsResizing(false);
        propsOnResizeEnd?.(widths);
    }, [
        propsOnResizeEnd,
        setIsInResizeMode,
        setIsResizing
    ]);
    let focusedKey = state.selectionManager.focusedKey;
    let dropTargetKey = null;
    if (dropState?.target?.type === 'item') {
        dropTargetKey = dropState.target.key;
        if (dropState.target.dropPosition === 'before' && dropTargetKey !== state.collection.getFirstKey()) // Normalize to the "after" drop position since we only render those in the DOM.
        // The exception to this is for the first row in the table, where we also render the "before" position.
        dropTargetKey = state.collection.getKeyBefore(dropTargetKey);
    }
    let persistedKeys = (0, $9YFnB$useMemo)(()=>{
        return new Set([
            focusedKey,
            dropTargetKey
        ].filter((k)=>k !== null));
    }, [
        focusedKey,
        dropTargetKey
    ]);
    let mergedProps = (0, $9YFnB$mergeProps)(isTableDroppable ? droppableCollection?.collectionProps : null, gridProps, focusProps);
    if (dragAndDropHooks?.isVirtualDragging?.()) mergedProps.tabIndex = undefined;
    return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$export$93e4b0b2cc49b648.Provider, {
        value: {
            state: state,
            dragState: dragState,
            dropState: dropState,
            dragAndDropHooks: dragAndDropHooks,
            isTableDraggable: isTableDraggable,
            isTableDroppable: isTableDroppable,
            layout: layout,
            onResizeStart: onResizeStart,
            onResize: props.onResize,
            onResizeEnd: onResizeEnd,
            headerRowHovered: headerRowHovered,
            isInResizeMode: isInResizeMode,
            setIsInResizeMode: setIsInResizeMode,
            isEmpty: isEmpty,
            onFocusedResizer: onFocusedResizer,
            headerMenuOpen: headerMenuOpen,
            setHeaderMenuOpen: setHeaderMenuOpen,
            renderEmptyState: props.renderEmptyState
        }
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableVirtualizer, {
        ...mergedProps,
        ...styleProps,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table', `spectrum-Table--${density}`, {
            'spectrum-Table--quiet': isQuiet,
            'spectrum-Table--wrap': props.overflowMode === 'wrap',
            'spectrum-Table--loadingMore': state.collection.body.props.loadingState === 'loadingMore',
            'spectrum-Table--isVerticalScrollbarVisible': isVerticalScrollbarVisible,
            'spectrum-Table--isHorizontalScrollbarVisible': isHorizontalScrollbarVisible
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'react-spectrum-Table'), styleProps.className),
        tableState: state,
        layout: layout,
        collection: state.collection,
        persistedKeys: persistedKeys,
        renderView: renderView,
        renderWrapper: renderWrapper,
        onVisibleRectChange: onVisibleRectChange,
        domRef: domRef,
        headerRef: headerRef,
        bodyRef: bodyRef,
        isFocusVisible: isFocusVisible,
        isVirtualDragging: dragAndDropHooks?.isVirtualDragging?.() || false,
        isRootDropTarget: isRootDropTarget
    }), DragPreview && isTableDraggable && dragAndDropHooks && dragState && /*#__PURE__*/ (0, $9YFnB$react).createElement(DragPreview, {
        ref: preview
    }, ()=>{
        if (dragState.draggedKey == null) return null;
        if (dragAndDropHooks.renderPreview) return dragAndDropHooks.renderPreview(dragState.draggingKeys, dragState.draggedKey);
        let itemCount = dragState.draggingKeys.size;
        let maxWidth = bodyRef.current.getBoundingClientRect().width;
        let height = $2a45525f66468ec9$var$ROW_HEIGHTS[density][scale];
        let itemText = state.collection.getTextValue(dragState.draggedKey);
        return /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $98bc3ab36527e684$export$905ab40ac2179daa), {
            itemText: itemText,
            itemCount: itemCount,
            height: height,
            maxWidth: maxWidth
        });
    }));
}
// This is a custom Virtualizer that also has a header that syncs its scroll position with the body.
function $2a45525f66468ec9$var$TableVirtualizer(props) {
    let { tableState: tableState, layout: layout, collection: collection, persistedKeys: persistedKeys, renderView: renderView, renderWrapper: renderWrapper, domRef: domRef, bodyRef: bodyRef, headerRef: headerRef, onVisibleRectChange: onVisibleRectChangeProp, isFocusVisible: isFocusVisible, isVirtualDragging: isVirtualDragging, isRootDropTarget: isRootDropTarget, ...otherProps } = props;
    let { direction: direction } = (0, $9YFnB$useLocale)();
    let loadingState = collection.body.props.loadingState;
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    let onLoadMore = collection.body.props.onLoadMore;
    let [tableWidth, setTableWidth] = (0, $9YFnB$useState)(0);
    let { scale: scale } = (0, $71dfb0e0358a12de$export$693cdb10cec23617)();
    const getDefaultWidth = (0, $9YFnB$useCallback)(({ props: { hideHeader: hideHeader, isSelectionCell: isSelectionCell, showDivider: showDivider, isDragButtonCell: isDragButtonCell } })=>{
        if (hideHeader) {
            let width = $2a45525f66468ec9$var$DEFAULT_HIDE_HEADER_CELL_WIDTH[scale];
            return showDivider ? width + 1 : width;
        } else if (isSelectionCell) return $2a45525f66468ec9$var$SELECTION_CELL_DEFAULT_WIDTH[scale];
        else if (isDragButtonCell) return $2a45525f66468ec9$var$DRAG_BUTTON_CELL_DEFAULT_WIDTH[scale];
    }, [
        scale
    ]);
    const getDefaultMinWidth = (0, $9YFnB$useCallback)(({ props: { hideHeader: hideHeader, isSelectionCell: isSelectionCell, showDivider: showDivider, isDragButtonCell: isDragButtonCell } })=>{
        if (hideHeader) {
            let width = $2a45525f66468ec9$var$DEFAULT_HIDE_HEADER_CELL_WIDTH[scale];
            return showDivider ? width + 1 : width;
        } else if (isSelectionCell) return $2a45525f66468ec9$var$SELECTION_CELL_DEFAULT_WIDTH[scale];
        else if (isDragButtonCell) return $2a45525f66468ec9$var$DRAG_BUTTON_CELL_DEFAULT_WIDTH[scale];
        return 75;
    }, [
        scale
    ]);
    let columnResizeState = (0, $9YFnB$useTableColumnResizeState)({
        tableWidth: tableWidth,
        getDefaultWidth: getDefaultWidth,
        getDefaultMinWidth: getDefaultMinWidth
    }, tableState);
    let state = (0, $9YFnB$useVirtualizerState)({
        layout: layout,
        collection: collection,
        renderView: renderView,
        onVisibleRectChange (rect) {
            if (bodyRef.current) {
                bodyRef.current.scrollTop = rect.y;
                (0, $9YFnB$setScrollLeft)(bodyRef.current, direction, rect.x);
            }
        },
        persistedKeys: persistedKeys,
        layoutOptions: (0, $9YFnB$useMemo)(()=>({
                columnWidths: columnResizeState.columnWidths
            }), [
            columnResizeState.columnWidths
        ])
    });
    (0, $9YFnB$useLoadMore)({
        isLoading: isLoading,
        onLoadMore: onLoadMore,
        scrollOffset: 1
    }, bodyRef);
    let onVisibleRectChange = (0, $9YFnB$useCallback)((rect)=>{
        state.setVisibleRect(rect);
    }, [
        state
    ]);
    let onVisibleRectChangeMemo = (0, $9YFnB$useCallback)((rect)=>{
        setTableWidth(rect.width);
        onVisibleRectChange(rect);
        onVisibleRectChangeProp(rect);
    }, [
        onVisibleRectChange,
        onVisibleRectChangeProp
    ]);
    // this effect runs whenever the contentSize changes, it doesn't matter what the content size is
    // only that it changes in a resize, and when that happens, we want to sync the body to the
    // header scroll position
    (0, $9YFnB$useEffect)(()=>{
        if ((0, $9YFnB$getInteractionModality)() === 'keyboard' && headerRef.current && (0, $9YFnB$isFocusWithin)(headerRef.current) && bodyRef.current) {
            let activeElement = (0, $9YFnB$getActiveElement)();
            (0, $9YFnB$scrollIntoView)(headerRef.current, activeElement);
            (0, $9YFnB$scrollIntoViewport)(activeElement, {
                containingElement: domRef.current
            });
            bodyRef.current.scrollLeft = headerRef.current.scrollLeft;
        }
    }, [
        state.contentSize,
        headerRef,
        bodyRef,
        domRef
    ]);
    let headerHeight = layout.getLayoutInfo('header')?.rect.height || 0;
    // Sync the scroll position from the table body to the header container.
    let onScroll = (0, $9YFnB$useCallback)(()=>{
        if (headerRef.current && bodyRef.current) headerRef.current.scrollLeft = bodyRef.current.scrollLeft;
    }, [
        bodyRef,
        headerRef
    ]);
    let resizerPosition = columnResizeState.resizingColumn != null ? layout.getLayoutInfo(columnResizeState.resizingColumn).rect.maxX - 2 : 0;
    let resizerAtEdge = resizerPosition > Math.max(state.virtualizer.contentSize.width, state.virtualizer.visibleRect.width) - 3;
    // this should be fine, every movement of the resizer causes a rerender
    // scrolling can cause it to lag for a moment, but it's always updated
    let resizerInVisibleRegion = resizerPosition < state.virtualizer.visibleRect.maxX;
    let shouldHardCornerResizeCorner = resizerAtEdge && resizerInVisibleRegion;
    // minimize re-render caused on Resizers by memoing this
    let resizingColumnWidth = columnResizeState.resizingColumn != null ? columnResizeState.getColumnWidth(columnResizeState.resizingColumn) : 0;
    let resizingColumn = (0, $9YFnB$useMemo)(()=>({
            width: resizingColumnWidth,
            key: columnResizeState.resizingColumn
        }), [
        resizingColumnWidth,
        columnResizeState.resizingColumn
    ]);
    if (isVirtualDragging) otherProps.tabIndex = undefined;
    let firstColumn = collection.columns[0];
    let scrollPadding = 0;
    if (firstColumn.props.isSelectionCell || firstColumn.props.isDragButtonCell) scrollPadding = columnResizeState.getColumnWidth(firstColumn.key);
    let visibleViews = $2a45525f66468ec9$var$renderChildren(null, state.visibleViews, renderWrapper);
    return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$export$d288a7dd40372bc.Provider, {
        value: resizingColumn
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$FocusScope), null, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...otherProps,
        ref: domRef
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        role: "presentation",
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-headWrapper'),
        style: {
            height: headerHeight,
            overflow: 'hidden',
            position: 'relative',
            willChange: state.isScrolling ? 'scroll-position' : undefined,
            scrollPaddingInlineStart: scrollPadding
        },
        ref: headerRef
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $5d98d27e710cc12e$export$b517d84d4ad20b24).Provider, {
        value: columnResizeState
    }, visibleViews[0])), /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$ScrollView), {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-body', {
            'focus-ring': isFocusVisible,
            'spectrum-Table-body--resizerAtTableEdge': shouldHardCornerResizeCorner
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'react-spectrum-Table-body', {
            'react-spectrum-Table-body--dropTarget': !!isRootDropTarget
        })),
        //  Firefox and Chrome make generic elements using CSS overflow 'scroll' or 'auto' tabbable,
        //  including them within the accessibility tree, which breaks the table structure in Firefox.
        //  Using tabIndex={-1} prevents the ScrollView from being tabbable, and using role="rowgroup"
        //  here and role="presentation" on the table body content fixes the table structure.
        role: "rowgroup",
        tabIndex: isVirtualDragging ? undefined : -1,
        style: {
            flex: 1,
            scrollPaddingInlineStart: scrollPadding
        },
        innerStyle: {
            overflow: 'visible'
        },
        ref: bodyRef,
        contentSize: state.contentSize,
        onVisibleRectChange: onVisibleRectChangeMemo,
        onScrollStart: state.startScrolling,
        onScrollEnd: state.endScrolling,
        onScroll: onScroll
    }, visibleViews[1], /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-bodyResizeIndicator'),
        style: {
            [direction === 'ltr' ? 'left' : 'right']: `${resizerPosition}px`,
            height: `${Math.max(state.virtualizer.contentSize.height, state.virtualizer.visibleRect.height)}px`,
            display: columnResizeState.resizingColumn ? 'block' : 'none'
        }
    })))));
}
function $2a45525f66468ec9$var$renderChildren(parent, views, renderWrapper) {
    return views.map((view)=>{
        return renderWrapper(parent, view, view.children ? Array.from(view.children) : [], (childViews)=>$2a45525f66468ec9$var$renderChildren(view, childViews, renderWrapper));
    });
}
function $2a45525f66468ec9$var$useStyle(layoutInfo, parent) {
    let { direction: direction } = (0, $9YFnB$useLocale)();
    let style = (0, $9YFnB$layoutInfoToStyle)(layoutInfo, direction, parent);
    if (style.overflow === 'hidden') style.overflow = 'visible'; // needed to support position: sticky
    return style;
}
function $2a45525f66468ec9$var$TableHeader({ children: children, layoutInfo: layoutInfo, parent: parent, ...otherProps }) {
    let { rowGroupProps: rowGroupProps } = (0, $9YFnB$useTableRowGroup)();
    let style = $2a45525f66468ec9$var$useStyle(layoutInfo, parent);
    return /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...rowGroupProps,
        ...otherProps,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-head'),
        style: style
    }, children);
}
function $2a45525f66468ec9$var$TableColumnHeader(props) {
    let { column: column } = props;
    let ref = (0, $9YFnB$useRef)(null);
    let { state: state, isEmpty: isEmpty } = $2a45525f66468ec9$export$3cb274deb6c2d854();
    let { pressProps: pressProps, isPressed: isPressed } = (0, $9YFnB$usePress)({
        isDisabled: isEmpty
    });
    let columnProps = column.props;
    (0, $9YFnB$useEffect)(()=>{
        if (column.hasChildNodes && columnProps.allowsResizing && process.env.NODE_ENV !== 'production') console.warn(`Column key: ${column.key}. Columns with child columns don't allow resizing.`);
    }, [
        column.hasChildNodes,
        column.key,
        columnProps.allowsResizing
    ]);
    let { columnHeaderProps: columnHeaderProps } = (0, $9YFnB$useTableColumnHeader)({
        node: column,
        isVirtualized: true
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $9YFnB$useHover)({
        ...props,
        isDisabled: isEmpty
    });
    const allProps = [
        columnHeaderProps,
        hoverProps,
        pressProps
    ];
    return /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...(0, $9YFnB$mergeProps)(...allProps),
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-headCell', {
            'is-active': isPressed,
            'is-sortable': columnProps.allowsSorting,
            'is-sorted-desc': state.sortDescriptor?.column === column.key && state.sortDescriptor?.direction === 'descending',
            'is-sorted-asc': state.sortDescriptor?.column === column.key && state.sortDescriptor?.direction === 'ascending',
            'is-hovered': isHovered,
            'spectrum-Table-cell--hideHeader': columnProps.hideHeader
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'react-spectrum-Table-cell', {
            'react-spectrum-Table-cell--alignCenter': columnProps.align === 'center' || column.colSpan > 1,
            'react-spectrum-Table-cell--alignEnd': columnProps.align === 'end'
        }))
    }, columnProps.allowsSorting && /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$spectrumiconsuiArrowDownSmall), {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-sortedIcon')
    }), columnProps.hideHeader ? /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$VisuallyHidden), null, column.rendered) : /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-headCellContents')
    }, column.rendered)));
}
let $2a45525f66468ec9$var$ForwardTableColumnHeaderButton = (props, ref)=>{
    let { focusProps: focusProps, alignment: alignment, ...otherProps } = props;
    let { isEmpty: isEmpty } = $2a45525f66468ec9$export$3cb274deb6c2d854();
    let domRef = (0, $3c2c983d5210446c$export$96a734597687c040)(ref);
    let { buttonProps: buttonProps } = (0, $9YFnB$useButton)({
        ...otherProps,
        elementType: 'div',
        isDisabled: isEmpty
    }, domRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $9YFnB$useHover)({
        ...otherProps,
        isDisabled: isEmpty
    });
    return /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-headCellContents', {
            'is-hovered': isHovered
        }),
        ...hoverProps
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-headCellButton', {
            'spectrum-Table-headCellButton--alignStart': alignment === 'start',
            'spectrum-Table-headCellButton--alignCenter': alignment === 'center',
            'spectrum-Table-headCellButton--alignEnd': alignment === 'end'
        }),
        ...(0, $9YFnB$mergeProps)(buttonProps, focusProps),
        ref: domRef
    }, props.children));
};
let $2a45525f66468ec9$var$TableColumnHeaderButton = /*#__PURE__*/ (0, $9YFnB$react).forwardRef($2a45525f66468ec9$var$ForwardTableColumnHeaderButton);
function $2a45525f66468ec9$var$ResizableTableColumnHeader(props) {
    let { column: column } = props;
    let ref = (0, $9YFnB$useRef)(null);
    let triggerRef = (0, $9YFnB$useRef)(null);
    let resizingRef = (0, $9YFnB$useRef)(null);
    let { state: state, onResizeStart: onResizeStart, onResize: onResize, onResizeEnd: onResizeEnd, headerRowHovered: headerRowHovered, setIsInResizeMode: setIsInResizeMode, isEmpty: isEmpty, isInResizeMode: isInResizeMode, headerMenuOpen: headerMenuOpen, setHeaderMenuOpen: setHeaderMenuOpen } = $2a45525f66468ec9$export$3cb274deb6c2d854();
    let columnResizeState = (0, $9YFnB$useContext)((0, $5d98d27e710cc12e$export$b517d84d4ad20b24));
    let stringFormatter = (0, $9YFnB$useLocalizedStringFormatter)((0, ($parcel$interopDefault($9YFnB$intlStringsmjs))), '@react-spectrum/table');
    let { pressProps: pressProps, isPressed: isPressed } = (0, $9YFnB$usePress)({
        isDisabled: isEmpty
    });
    let { columnHeaderProps: columnHeaderProps } = (0, $9YFnB$useTableColumnHeader)({
        node: column,
        isVirtualized: true
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $9YFnB$useHover)({
        ...props,
        isDisabled: isEmpty || headerMenuOpen
    });
    const allProps = [
        columnHeaderProps,
        pressProps,
        hoverProps
    ];
    let columnProps = column.props;
    let { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $9YFnB$useFocusRing)();
    const onMenuSelect = (key)=>{
        switch(key){
            case 'sort-asc':
                state.sort(column.key, 'ascending');
                break;
            case 'sort-desc':
                state.sort(column.key, 'descending');
                break;
            case 'resize':
                columnResizeState.startResize(column.key);
                setIsInResizeMode(true);
                state.setKeyboardNavigationDisabled(true);
                break;
        }
    };
    let allowsSorting = column.props?.allowsSorting;
    let items = (0, $9YFnB$useMemo)(()=>{
        let options = [];
        if (allowsSorting) {
            options.push({
                label: stringFormatter.format('sortAscending'),
                id: 'sort-asc'
            });
            options.push({
                label: stringFormatter.format('sortDescending'),
                id: 'sort-desc'
            });
        }
        options.push({
            label: stringFormatter.format('resizeColumn'),
            id: 'resize'
        });
        return options;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowsSorting
    ]);
    let resizingColumn = columnResizeState.resizingColumn;
    let showResizer = !isEmpty && (headerRowHovered && (0, $9YFnB$getInteractionModality)() !== 'keyboard' || resizingColumn != null);
    let alignment = 'start';
    let menuAlign = 'start';
    if (columnProps.align === 'center' || column.colSpan > 1) alignment = 'center';
    else if (columnProps.align === 'end') {
        alignment = 'end';
        menuAlign = 'end';
    }
    return /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...(0, $9YFnB$mergeProps)(...allProps),
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-headCell', {
            'is-active': isPressed,
            'is-resizable': columnProps.allowsResizing,
            'is-sortable': columnProps.allowsSorting,
            'is-sorted-desc': state.sortDescriptor?.column === column.key && state.sortDescriptor?.direction === 'descending',
            'is-sorted-asc': state.sortDescriptor?.column === column.key && state.sortDescriptor?.direction === 'ascending',
            'is-hovered': isHovered,
            'focus-ring': isFocusVisible,
            'spectrum-Table-cell--hideHeader': columnProps.hideHeader
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'react-spectrum-Table-cell', {
            'react-spectrum-Table-cell--alignCenter': alignment === 'center',
            'react-spectrum-Table-cell--alignEnd': alignment === 'end'
        }))
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9928637078ff3033$export$27d2ad3c5815583e), {
        onOpenChange: setHeaderMenuOpen,
        align: menuAlign
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableColumnHeaderButton, {
        alignment: alignment,
        ref: triggerRef,
        focusProps: focusProps
    }, columnProps.allowsSorting && /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$spectrumiconsuiArrowDownSmall), {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-sortedIcon')
    }), columnProps.hideHeader ? /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$VisuallyHidden), null, column.rendered) : /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-headerCellText')
    }, column.rendered), columnProps.allowsResizing && /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$spectrumiconsuiChevronDownMedium), {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-menuChevron')
    })), /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $8cccdb0b63bfcdeb$export$d9b273488cd8ce6f), {
        onAction: onMenuSelect,
        minWidth: "size-2000",
        items: items
    }, (item)=>/*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$Item), null, item.label))), /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $5d98d27e710cc12e$export$48a76196cafe3b93), {
        ref: resizingRef,
        column: column,
        showResizer: showResizer,
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeEnd: onResizeEnd,
        triggerRef: (0, $3c2c983d5210446c$export$1d5cc31d9d8df817)(triggerRef)
    }), /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        "aria-hidden": true,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-colResizeIndicator', {
            'spectrum-Table-colResizeIndicator--visible': resizingColumn != null,
            'spectrum-Table-colResizeIndicator--resizing': resizingColumn === column.key
        })
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-colResizeNubbin', {
            'spectrum-Table-colResizeNubbin--visible': isInResizeMode && resizingColumn === column.key
        })
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $883c77333b1378a3$export$d9658cdf8c86807), null)))));
}
function $2a45525f66468ec9$var$TableSelectAllCell({ column: column }) {
    let ref = (0, $9YFnB$useRef)(null);
    let { state: state } = $2a45525f66468ec9$export$3cb274deb6c2d854();
    let isSingleSelectionMode = state.selectionManager.selectionMode === 'single';
    let { columnHeaderProps: columnHeaderProps } = (0, $9YFnB$useTableColumnHeader)({
        node: column,
        isVirtualized: true
    }, state, ref);
    let { checkboxProps: checkboxProps } = (0, $9YFnB$useTableSelectAllCheckbox)(state);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $9YFnB$useHover)({});
    return /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...(0, $9YFnB$mergeProps)(columnHeaderProps, hoverProps),
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-headCell', 'spectrum-Table-checkboxCell', {
            'is-hovered': isHovered
        })
    }, /*
            In single selection mode, the checkbox will be hidden.
            So to avoid leaving a column header with no accessible content,
            we use a VisuallyHidden component to include the aria-label from the checkbox,
            which for single selection will be "Select."
          */ isSingleSelectionMode && /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$VisuallyHidden), null, checkboxProps['aria-label']), /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $b50e47f9c64ebdde$export$48513f6b9f8ce62d), {
        ...checkboxProps,
        "data-testid": "selectAll",
        isEmphasized: true,
        UNSAFE_style: isSingleSelectionMode ? {
            visibility: 'hidden'
        } : undefined,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-checkbox')
    })));
}
function $2a45525f66468ec9$var$TableDragHeaderCell({ column: column }) {
    let ref = (0, $9YFnB$useRef)(null);
    let { state: state } = $2a45525f66468ec9$export$3cb274deb6c2d854();
    let { columnHeaderProps: columnHeaderProps } = (0, $9YFnB$useTableColumnHeader)({
        node: column,
        isVirtualized: true
    }, state, ref);
    let stringFormatter = (0, $9YFnB$useLocalizedStringFormatter)((0, ($parcel$interopDefault($9YFnB$intlStringsmjs))), '@react-spectrum/table');
    return /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...columnHeaderProps,
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-headCell', (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'react-spectrum-Table-headCell', 'react-spectrum-Table-dragButtonHeadCell'))
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$VisuallyHidden), null, stringFormatter.format('drag'))));
}
function $2a45525f66468ec9$var$TableRowGroup({ children: children, layoutInfo: layoutInfo, parent: parent, ...otherProps }) {
    let { rowGroupProps: rowGroupProps } = (0, $9YFnB$useTableRowGroup)();
    let { isTableDroppable: isTableDroppable } = (0, $9YFnB$useContext)($2a45525f66468ec9$export$93e4b0b2cc49b648);
    let style = $2a45525f66468ec9$var$useStyle(layoutInfo, parent);
    return /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...rowGroupProps,
        style: style,
        ...otherProps
    }, isTableDroppable && /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $104a371d434f1691$export$d30a7814cfd4033e), {
        key: "root"
    }), children);
}
function $2a45525f66468ec9$var$DragButton() {
    let { dragButtonProps: dragButtonProps, dragButtonRef: dragButtonRef, isFocusVisibleWithin: isFocusVisibleWithin } = $2a45525f66468ec9$export$cd7c5802f9e21187();
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $9YFnB$useVisuallyHidden)();
    return /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...dragButtonProps,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'react-spectrum-Table-dragButton'),
        style: !isFocusVisibleWithin ? {
            ...visuallyHiddenProps.style
        } : {},
        ref: dragButtonRef,
        draggable: "true"
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$spectrumiconsuiListGripper), {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))))
    })));
}
const $2a45525f66468ec9$var$TableRowContext = /*#__PURE__*/ (0, $9YFnB$react).createContext(null);
function $2a45525f66468ec9$export$cd7c5802f9e21187() {
    return (0, $9YFnB$useContext)($2a45525f66468ec9$var$TableRowContext);
}
function $2a45525f66468ec9$var$TableRow({ item: item, children: children, layoutInfo: layoutInfo, parent: parent, ...otherProps }) {
    let ref = (0, $9YFnB$useRef)(null);
    let { state: state, layout: layout, dragAndDropHooks: dragAndDropHooks, isTableDraggable: isTableDraggable, isTableDroppable: isTableDroppable, dragState: dragState, dropState: dropState } = $2a45525f66468ec9$export$3cb274deb6c2d854();
    let isSelected = state.selectionManager.isSelected(item.key);
    let { rowProps: rowProps, hasAction: hasAction, allowsSelection: allowsSelection } = (0, $9YFnB$useTableRow)({
        node: item,
        isVirtualized: true,
        shouldSelectOnPressUp: isTableDraggable
    }, state, ref);
    let isDisabled = state.selectionManager.isDisabled(item.key);
    let isInteractive = !isDisabled && (hasAction || allowsSelection || isTableDraggable);
    let { pressProps: pressProps, isPressed: isPressed } = (0, $9YFnB$usePress)({
        isDisabled: !isInteractive
    });
    // The row should show the focus background style when any cell inside it is focused.
    // If the row itself is focused, then it should have a blue focus indicator on the left.
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, $9YFnB$useFocusRing)({
        within: true
    });
    let { isFocusVisible: isFocusVisible, focusProps: focusProps } = (0, $9YFnB$useFocusRing)();
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $9YFnB$useHover)({
        isDisabled: !isInteractive
    });
    let isFirstRow = state.collection.rows.find((row)=>row.type === 'item' && row.level === 0)?.key === item.key;
    let isLastRow = item.nextKey == null;
    // Figure out if the TableView content is equal or greater in height to the container. If so, we'll need to round the bottom
    // border corners of the last row when selected.
    let isFlushWithContainerBottom = false;
    if (isLastRow) {
        if (layout.getContentSize()?.height >= (layout.virtualizer?.visibleRect.height ?? 0)) isFlushWithContainerBottom = true;
    }
    let draggableItem = null;
    if (isTableDraggable && dragAndDropHooks && dragState) {
        draggableItem = dragAndDropHooks.useDraggableItem({
            key: item.key,
            hasDragButton: true
        }, dragState);
        if (isDisabled) draggableItem = null;
    }
    let isDropTarget = false;
    let dropIndicator = null;
    let dropIndicatorRef = (0, $9YFnB$useRef)(null);
    if (isTableDroppable && dragAndDropHooks && dropState) {
        let target = {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        };
        isDropTarget = dropState.isDropTarget(target);
        dropIndicator = dragAndDropHooks.useDropIndicator({
            target: target
        }, dropState, dropIndicatorRef);
    }
    let dragButtonRef = (0, $9YFnB$react).useRef(null);
    let { buttonProps: dragButtonProps } = (0, $9YFnB$useButton)({
        ...draggableItem?.dragButtonProps,
        elementType: 'div'
    }, dragButtonRef);
    let style = $2a45525f66468ec9$var$useStyle(layoutInfo, parent);
    let props = (0, $9YFnB$mergeProps)(rowProps, otherProps, {
        style: style
    }, focusWithinProps, focusProps, hoverProps, pressProps, draggableItem?.dragProps, // Remove tab index from list row if performing a screenreader drag. This prevents TalkBack from focusing the row,
    // allowing for single swipe navigation between row drop indicator
    dragAndDropHooks?.isVirtualDragging?.() ? {
        tabIndex: null
    } : null);
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $9YFnB$useVisuallyHidden)();
    return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$TableRowContext.Provider, {
        value: {
            dragButtonProps: dragButtonProps,
            dragButtonRef: dragButtonRef,
            isFocusVisibleWithin: isFocusVisibleWithin
        }
    }, isTableDroppable && isFirstRow && /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9b909c804a6da52e$export$2c0bab5914a9d088), {
        rowProps: props,
        key: `${item.key}-before`,
        target: {
            key: item.key,
            type: 'item',
            dropPosition: 'before'
        }
    }), isTableDroppable && !dropIndicator?.isHidden && /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        role: "row",
        ...visuallyHiddenProps
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        role: "gridcell"
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        role: "button",
        ...dropIndicator?.dropIndicatorProps,
        ref: dropIndicatorRef
    }))), /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...props,
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-row', {
            'is-active': isPressed,
            'is-selected': isSelected,
            'spectrum-Table-row--highlightSelection': state.selectionManager.selectionBehavior === 'replace',
            'is-next-selected': item.nextKey != null && state.selectionManager.isSelected(item.nextKey),
            'is-focused': isFocusVisibleWithin,
            'focus-ring': isFocusVisible,
            'is-hovered': isHovered,
            'is-disabled': isDisabled,
            'spectrum-Table-row--firstRow': isFirstRow,
            'spectrum-Table-row--lastRow': isLastRow,
            'spectrum-Table-row--isFlushBottom': isFlushWithContainerBottom
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'react-spectrum-Table-row', {
            'react-spectrum-Table-row--dropTarget': isDropTarget
        }))
    }, children), isTableDroppable && /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9b909c804a6da52e$export$2c0bab5914a9d088), {
        rowProps: props,
        key: `${item.key}-after`,
        target: {
            key: item.key,
            type: 'item',
            dropPosition: 'after'
        }
    }));
}
function $2a45525f66468ec9$var$TableHeaderRow({ item: item, children: children, layoutInfo: layoutInfo, parent: parent, ...props }) {
    let { state: state, headerMenuOpen: headerMenuOpen } = $2a45525f66468ec9$export$3cb274deb6c2d854();
    let ref = (0, $9YFnB$useRef)(null);
    let { rowProps: rowProps } = (0, $9YFnB$useTableHeaderRow)({
        node: item,
        isVirtualized: true
    }, state, ref);
    let { hoverProps: hoverProps } = (0, $9YFnB$useHover)({
        ...props,
        isDisabled: headerMenuOpen
    });
    let style = $2a45525f66468ec9$var$useStyle(layoutInfo, parent);
    return /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...(0, $9YFnB$mergeProps)(rowProps, hoverProps),
        ref: ref,
        style: style
    }, children);
}
function $2a45525f66468ec9$var$TableDragCell({ cell: cell }) {
    let ref = (0, $9YFnB$useRef)(null);
    let { state: state, isTableDraggable: isTableDraggable } = $2a45525f66468ec9$export$3cb274deb6c2d854();
    let isDisabled = state.selectionManager.isDisabled(cell.parentKey);
    let { gridCellProps: gridCellProps } = (0, $9YFnB$useTableCell)({
        node: cell,
        isVirtualized: true
    }, state, ref);
    return /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...gridCellProps,
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-cell', {
            'is-disabled': isDisabled
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'react-spectrum-Table-cell', 'react-spectrum-Table-dragButtonCell'))
    }, isTableDraggable && !isDisabled && /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$DragButton, null)));
}
function $2a45525f66468ec9$var$TableCheckboxCell({ cell: cell }) {
    let ref = (0, $9YFnB$useRef)(null);
    let { state: state } = $2a45525f66468ec9$export$3cb274deb6c2d854();
    // The TableCheckbox should always render its disabled status if the row is disabled, regardless of disabledBehavior,
    // but the cell itself should not render its disabled styles if disabledBehavior="selection" because the row might have actions on it.
    let isSelectionDisabled = state.disabledKeys.has(cell.parentKey);
    let isDisabled = state.selectionManager.isDisabled(cell.parentKey);
    let { gridCellProps: gridCellProps } = (0, $9YFnB$useTableCell)({
        node: cell,
        isVirtualized: true
    }, state, ref);
    let { checkboxProps: checkboxProps } = (0, $9YFnB$useTableSelectionCheckbox)({
        key: cell.parentKey
    }, state);
    return /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...gridCellProps,
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-cell', 'spectrum-Table-checkboxCell', {
            'is-disabled': isDisabled
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'react-spectrum-Table-cell'))
    }, state.selectionManager.selectionMode !== 'none' && /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $b50e47f9c64ebdde$export$48513f6b9f8ce62d), {
        ...checkboxProps,
        isEmphasized: true,
        isDisabled: isSelectionDisabled,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-checkbox')
    })));
}
function $2a45525f66468ec9$var$TableCell({ cell: cell }) {
    let { scale: scale } = (0, $71dfb0e0358a12de$export$693cdb10cec23617)();
    let state = $2a45525f66468ec9$export$3cb274deb6c2d854().state;
    let isExpandableTable = 'keyMap' in state;
    let ref = (0, $9YFnB$useRef)(null);
    let columnProps = cell.column.props;
    let isDisabled = state.selectionManager.isDisabled(cell.parentKey);
    let { gridCellProps: gridCellProps } = (0, $9YFnB$useTableCell)({
        node: cell,
        isVirtualized: true
    }, state, ref);
    let { id: id, ...otherGridCellProps } = gridCellProps;
    let isFirstRowHeaderCell = state.collection.rowHeaderColumnKeys.keys().next().value === cell.column.key;
    let isRowExpandable = false;
    let showExpandCollapseButton = false;
    let levelOffset = 0;
    if ('keyMap' in state) {
        isRowExpandable = state.keyMap.get(cell.parentKey)?.props.UNSTABLE_childItems?.length > 0 || state.keyMap.get(cell.parentKey)?.props?.children?.length > state.userColumnCount;
        showExpandCollapseButton = isFirstRowHeaderCell && isRowExpandable;
        // Offset based on level, and add additional offset if there is no expand/collapse button on a row
        levelOffset = (cell.level - 1) * $2a45525f66468ec9$var$LEVEL_OFFSET_WIDTH[scale] + (!showExpandCollapseButton ? $2a45525f66468ec9$var$LEVEL_OFFSET_WIDTH[scale] * 2 : 0);
    }
    return /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        ...otherGridCellProps,
        "aria-labelledby": id,
        ref: ref,
        style: isExpandableTable && isFirstRowHeaderCell ? {
            paddingInlineStart: levelOffset
        } : {},
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-cell', {
            'spectrum-Table-cell--divider': columnProps.showDivider && cell.column.nextKey !== null,
            'spectrum-Table-cell--hideHeader': columnProps.hideHeader,
            'spectrum-Table-cell--hasExpandCollapseButton': showExpandCollapseButton,
            'is-disabled': isDisabled
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'react-spectrum-Table-cell', {
            'react-spectrum-Table-cell--alignStart': columnProps.align === 'start',
            'react-spectrum-Table-cell--alignCenter': columnProps.align === 'center',
            'react-spectrum-Table-cell--alignEnd': columnProps.align === 'end'
        }))
    }, showExpandCollapseButton && /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$ExpandableRowChevron, {
        cell: cell
    }), /*#__PURE__*/ (0, $9YFnB$react).createElement("span", {
        id: id,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-cellContents')
    }, cell.rendered)));
}
function $2a45525f66468ec9$var$TableCellWrapper({ layoutInfo: layoutInfo, virtualizer: virtualizer, parent: parent, children: children }) {
    let { isTableDroppable: isTableDroppable, dropState: dropState } = (0, $9YFnB$useContext)($2a45525f66468ec9$export$93e4b0b2cc49b648);
    let isDropTarget = false;
    let isRootDroptarget = false;
    if (isTableDroppable && dropState) {
        if (parent.content) isDropTarget = dropState.isDropTarget({
            type: 'item',
            dropPosition: 'on',
            key: parent.content.key
        });
        isRootDroptarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    return /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$VirtualizerItem), {
        layoutInfo: layoutInfo,
        virtualizer: virtualizer,
        parent: parent?.layoutInfo,
        className: (0, $9YFnB$useMemo)(()=>(0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-cellWrapper', (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), {
                'react-spectrum-Table-cellWrapper': !layoutInfo.estimatedSize,
                'react-spectrum-Table-cellWrapper--dropTarget': isDropTarget || isRootDroptarget
            })), [
            layoutInfo.estimatedSize,
            isDropTarget,
            isRootDroptarget
        ])
    }, children);
}
function $2a45525f66468ec9$var$ExpandableRowChevron({ cell: cell }) {
    // TODO: move some/all of the chevron button setup into a separate hook?
    let { direction: direction } = (0, $9YFnB$useLocale)();
    let state = $2a45525f66468ec9$export$3cb274deb6c2d854().state;
    let expandButtonRef = (0, $9YFnB$useRef)(null);
    let stringFormatter = (0, $9YFnB$useLocalizedStringFormatter)((0, ($parcel$interopDefault($9YFnB$intlStringsmjs))), '@react-spectrum/table');
    let isExpanded;
    if ('keyMap' in state) isExpanded = state.expandedKeys === 'all' || state.expandedKeys.has(cell.parentKey);
    // Will need to keep the chevron as a button for iOS VO at all times since VO doesn't focus the cell. Also keep as button if cellAction is defined by the user in the future
    let { buttonProps: buttonProps } = (0, $9YFnB$useButton)({
        // Desktop and mobile both toggle expansion of a native expandable row on mouse/touch up
        onPress: ()=>{
            state.toggleKey(cell.parentKey);
            if (!(0, $9YFnB$isFocusVisible)()) {
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(cell.parentKey);
            }
        },
        elementType: 'span',
        'aria-label': isExpanded ? stringFormatter.format('collapse') : stringFormatter.format('expand')
    }, expandButtonRef);
    return /*#__PURE__*/ (0, $9YFnB$react).createElement("span", {
        ...buttonProps,
        ref: expandButtonRef,
        // Override tabindex so that grid keyboard nav skips over it. Needs -1 so android talkback can actually "focus" it
        tabIndex: (0, $9YFnB$isAndroid)() ? -1 : undefined,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_vars_cssmjs))), 'spectrum-Table-expandButton', {
            'is-open': isExpanded
        })
    }, direction === 'ltr' ? /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$spectrumiconsuiChevronRightMedium), null) : /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $9YFnB$spectrumiconsuiChevronLeftMedium), null));
}
function $2a45525f66468ec9$var$LoadingState() {
    let { state: state } = (0, $9YFnB$useContext)($2a45525f66468ec9$export$93e4b0b2cc49b648);
    let stringFormatter = (0, $9YFnB$useLocalizedStringFormatter)((0, ($parcel$interopDefault($9YFnB$intlStringsmjs))), '@react-spectrum/table');
    return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$CenteredWrapper, null, /*#__PURE__*/ (0, $9YFnB$react).createElement((0, $1cfe37e7feefa23d$export$c79b9d6b4cc92af7), {
        isIndeterminate: true,
        "aria-label": state.collection.size > 0 ? stringFormatter.format('loadingMore') : stringFormatter.format('loading')
    }));
}
function $2a45525f66468ec9$var$EmptyState() {
    let { renderEmptyState: renderEmptyState } = (0, $9YFnB$useContext)($2a45525f66468ec9$export$93e4b0b2cc49b648);
    let emptyState = renderEmptyState ? renderEmptyState() : null;
    if (emptyState == null) return null;
    return /*#__PURE__*/ (0, $9YFnB$react).createElement($2a45525f66468ec9$var$CenteredWrapper, null, emptyState);
}
function $2a45525f66468ec9$var$CenteredWrapper({ children: children }) {
    let state = $2a45525f66468ec9$export$3cb274deb6c2d854().state;
    let rowProps;
    if ('keyMap' in state) {
        let topLevelRowCount = [
            ...state.collection.body.childNodes
        ].length;
        rowProps = {
            'aria-level': 1,
            'aria-posinset': topLevelRowCount + 1,
            'aria-setsize': topLevelRowCount + 1
        };
    } else rowProps = {
        'aria-rowindex': state.collection.headerRows.length + state.collection.size + 1
    };
    return /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        role: "row",
        ...rowProps,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9YFnB$table_cssmjs))), 'react-spectrum-Table-centeredWrapper')
    }, /*#__PURE__*/ (0, $9YFnB$react).createElement("div", {
        role: "rowheader",
        "aria-colspan": state.collection.columns.length
    }, children));
}
const $2a45525f66468ec9$export$517e02184d273d69 = /*#__PURE__*/ (0, $9YFnB$react).forwardRef($2a45525f66468ec9$var$TableViewBase);


export {$2a45525f66468ec9$export$93e4b0b2cc49b648 as TableContext, $2a45525f66468ec9$export$3cb274deb6c2d854 as useTableContext, $2a45525f66468ec9$export$d288a7dd40372bc as VirtualizerContext, $2a45525f66468ec9$export$3f8f74b6bfd2c5df as useVirtualizerContext, $2a45525f66468ec9$export$cd7c5802f9e21187 as useTableRowContext, $2a45525f66468ec9$export$517e02184d273d69 as TableViewBase};
//# sourceMappingURL=TableViewBase.mjs.map
